import React, { useState } from "react";
import { getFirestore, doc, updateDoc } from "firebase/firestore";

const sanitizeInput = (input) => {
  return input
    .replace(/<[^>]*>?/gm, "")
    .replace(/[`$%^&*|\\]/g, "")
    .trim();
};

const AddHistory = ({ selectedPatient, onClose }) => {
  const [key, setKey] = useState("");
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const sanitizedKey = sanitizeInput(key);
    const sanitizedValue = sanitizeInput(value);

    if (!sanitizedKey || !sanitizedValue) {
      setError("Debes completar ambos campos con información válida.");
      return;
    }

    try {
      const db = getFirestore();
      const patientRef = doc(db, "registeredPatients", selectedPatient.id);

      await updateDoc(patientRef, {
        [`background.${sanitizedKey}`]: sanitizedValue,
      });

      setSuccess("El antecedente se guardó correctamente.");
      setError("");
      setKey("");
      setValue("");
    } catch (error) {
      setError("Ocurrió un error al guardar el antecedente.");
    }
  };

  return (
    <div className="addHistory">
      <h2>Registrar antecedente</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {success && <p style={{ color: "green" }}>{success}</p>}

      <form onSubmit={handleSubmit}>
        <div>
          <input
            type="text"
            placeholder="Tipo de antecedente"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            className="generalFormInput"
          />
        </div>
        <div>
          <input
            type="text"
            placeholder="Descripción"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="generalFormInput"
          />
        </div>
        <button type="submit">Guardar</button>
      </form>
    </div>
  );
};

export default AddHistory;
